import { render, staticRenderFns } from "./SuccessLinkButton.vue?vue&type=template&id=80c9b7e4"
import script from "./SuccessLinkButton.vue?vue&type=script&lang=js"
export * from "./SuccessLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports